import { Doc } from '@dadohr/shared/domainTypes/document';
import { IUser } from '@dadohr/shared/domainTypes/user';
import { FS } from '@dadohr/shared/versions';
import { keyBy } from 'lodash';
import moment from 'moment-timezone';
import shortid from 'shortid';
import { fromMoment } from '../../../services/time';
import { GeneratedUser, Generator } from './generator';

// @guide Add a field to the IUser object - 2.6.2 Add to super-admin app sample content user generator
export const generatedUsersToUsers = (
  orgId: string,
  samples: GeneratedUser[]
) => {
  const sampleUsersByEmail = keyBy(samples, (s) => s.email);
  const usersByEmail: { [userId: string]: Doc<IUser> } = {};
  const createUser = (u: GeneratedUser): Doc<IUser> => {
    if (usersByEmail[u.email]) {
      return usersByEmail[u.email];
    }

    const doc: Doc<IUser> = {
      id: shortid(),
      collection: FS.users,
      data: {
        email: u.email,
        personalEmail: '',
        firstName: u.firstName,
        middleName: '',
        preferredName: u.firstName,
        lastName: u.lastName,
        gender: u.gender === 'male' ? 'm' : u.gender === 'female' ? 'f' : 'u',
        managerId: u.managerEmail
          ? createUser(sampleUsersByEmail[u.managerEmail]).id
          : '',

        role: u.position,
        department: u.department,
        team: u.team,
        location: u.city,

        hireDate: fromMoment(moment(u.hireDate, 'M/D/YYYY')),
        terminationDate: null,
        dateOfBirth: null,

        orgId,
        alternateId: `${u.employeeId}`,
        active: true,
        address: null,
        phoneNumber: '',
        customFields: {}
      }
    };

    usersByEmail[u.email] = doc;
    return doc;
  };
  return samples.map(createUser);
};

const ONE_MINUTE = 1 * 1000 * 60;
const ONE_DAY = ONE_MINUTE * 60 * 24;
const ONE_YEAR = ONE_DAY * 365;

export const createSampleUsers = async (
  orgId: string,
  count: number
): Promise<Doc<IUser>[]> => {
  const generator = new Generator({
    cities: ['Berlin', 'New York', 'San Francisco'],
    hireDate: {
      min: new Date(Date.now() - ONE_YEAR * (1 / 2)),
      max: new Date(Date.now() + ONE_DAY * 21)
    }
  });
  const samples = await generator.generateHierarchy(count);
  return generatedUsersToUsers(orgId, samples);
};

/**
 * @deprecated Not relevant anymore - early day stuff
 */
export const getUsersFromSysAdmins = (orgId: string): Doc<IUser>[] => {
  return [];
};
